<div class="page-container">
  <app-banner-logo>
    <app-image-carousel
      banner-media
      [indicatorsVisible]="true"
      [animationSpeed]="400"
      [autoPlay]="true"
      [autoPlaySpeed]="5000"
    >
    </app-image-carousel>
  </app-banner-logo>

  <div class="main-body">
    <div class="section-container">

      <!-- Title -->
      <h1 class ="mat-display-medium">About Us</h1>

      <!-- Short paragraph -->
      <p>
        We are a team of highly experienced specialists in endocrinology and diabetes, dedicated to providing
        comprehensive and holistic care. With research doctorate and specialist qualifications, and guided by the core
        values of St Vincent’s Health Australia – excellence, compassion, integrity and justice – we strive to bring you
        the most advanced treatments for diabetes, metabolism and hormone disorder management. Our practice also prioritises good
        communication with patients, referring doctors and other health professionals to ensure the best possible
        outcomes.
      </p>
      <p>
        We are very conveniently located adjacent to St Vincent’s Clinic Bone Densitometry, Sydney Imaging Specialists, and pathology collection centres for both SydPath and Douglass Hanly Moir.
      </p>
    </div>

    <!-- Buttons -->
    <div class="section-container">
      <div class="flex-grid-thirds">
        <app-click-card
          class="col"
          link="/our-team"
          icon="groups"
          text="Our Team">
        </app-click-card>
        <app-click-card
          class="col"
          link="/conditions"
          icon="health_and_safety"
          text="Conditions We Treat">
        </app-click-card>
        <app-click-card
          class="col"
          link="/contact-us"
          icon="location_on"
          text="Contact Us">
        </app-click-card>
      </div>
    </div>
  </div>
</div>
